/**
 * Code commits still on their way (BLP/nx#3198). A field that resolves a typed
 * code on the server (`NxAutocompleteInput`'s `resolveCode`) lets Tab move on
 * at once, so fast typing goes into the next field, and commits the answer
 * into its own field when it arrives. A form that leaves the record — a new
 * record, the next one — first waits for these commits, or the late answer
 * would land in the record that follows.
 */
const pending = new Set<Promise<unknown>>();

/** Registers a commit in flight; it leaves the set when it settles. */
export function trackNxCodeCommit(commit: Promise<unknown>): void {
  pending.add(commit);
  void commit.finally(() => pending.delete(commit));
}

/** Resolves once every code commit in flight — and every one they start — has settled. */
export async function nxCodeCommitsSettled(): Promise<void> {
  while (pending.size > 0) {
    await Promise.allSettled([...pending]);
  }
}
